import { render, staticRenderFns } from "./EditOrderItem.template.vue?vue&type=template&id=85539704&scoped=true&"
var script = {}
import style0 from "./EditOrderItem.template.vue?vue&type=style&index=0&id=85539704&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85539704",
  null
  
)

export default component.exports